import { graphql } from 'react-relay';

export const ServiceAvailabilityStatusQuery = graphql`
    query serviceAvailabilityStatusQuery($serviceWithCredits: ServicesWithCredits!) {
        serviceAvailabilityStatus(serviceWithCredits: $serviceWithCredits)
    }
`;
